import { DatafinitiStatus } from './comparable';

export interface DatafinitiProperty {
  address: string;
  architecturalStyles?: string[];
  assessedValues?: AssessedValue[];
  brokers?: Broker[];
  categories?: string[];
  censusBlock?: number;
  censusBlockGroup?: number;
  censusTract?: number;
  city?: string;
  civilDivisionCode?: number;
  civilDivisionName?: string;
  congressionalDistrictHouse?: number;
  country?: string;
  county?: string;
  countyFIPS?: number;
  currentOwnerType?: string;
  dateAdded?: string;
  dateUpdated?: string;
  descriptions?: Description[];
  domains?: string[];
  exteriorConstruction?: string[];
  features?: Feature[];
  floorSizeValue?: number;
  floorSizeUnit?: string;
  geoLocation?: string;
  hvacTypes?: string[];
  imageURLs?: string[];
  instrumentNumber?: string;
  keys?: string[];
  latitude?: string;
  legalDescription?: string;
  listingName?: string;
  longitude?: string;
  lotSizeValue?: number;
  lotSizeUnit?: string;
  mostRecentPriceAmount?: number;
  mostRecentPriceDomain: string;
  mostRecentPriceDate?: string;
  mostRecentPriceFirstDateSeen?: string;
  mostRecentStatus?: string;
  mostRecentStatusDate?: string;
  mostRecentStatusFirstDateSeen?: string;
  mlsNumber?: string;
  msaCode?: number;
  msaName?: string;
  neighborhoods?: string[];
  numBathroom?: number;
  numBedroom: number;
  numFloor?: number;
  numParkingSpaces?: number;
  parking?: string[];
  people?: Person[];
  postalCode?: string;
  prices?: Price[];
  propertyTaxes?: PropertyTax[];
  propertyType: string;
  province?: string;
  sourceURLs?: string[];
  statuses?: DatafinitiStatus[];
  title?: string;
  transactions?: Transaction[];
  websiteIDs?: string[];
  yearBuilt?: number;
  id: string;
}

export interface AssessedValue {
  totalAmount?: number;
  improvementsAmount?: number;
  landAmount?: number;
  year?: number;
}

export interface Broker {
  agent?: string;
  company?: string;
  dateSeen?: string;
  emails?: string[];
  phones?: string[];
  sourceURLs?: string[];
  websites?: string[];
}

export interface Description {
  dateSeen?: string;
  sourceURLs?: string[];
  value?: string;
}

export interface Feature {
  value?: string[];
  key?: string;
  replace?: string;
}

export interface Person {
  dateSeen?: string;
  title?: string;
  name?: string;
  phone?: string;
}

export interface Price {
  amountMax?: number;
  amountMin?: number;
  availability?: string;
  currency?: Currency;
  date?: string;
  dateSeen?: string[];
  isSold?: string;
  sourceURLs?: string[];
  pricePerSquareFoot?: number;
  isSale?: string;
}

export enum Currency {
  Usd = 'USD',
}

export interface PropertyTax {
  amount?: number;
  currency?: Currency;
  sourceURLs?: string[];
  dateSeen?: string[];
}

export interface Status {
  date?: string;
  dateSeen?: string[];
  firstDateSeen?: string;
  lastDateSeen?: string;
  type?: string;
}

export interface Transaction {
  saleDate?: string;
  documentType?: string;
  price?: number;
  sellerFirstName?: string;
  sellerLastName?: string;
  buyerFirstName?: string;
  buyerLastName?: string;
  lenderName?: string;
  loanType?: string;
  loanAmount?: number;
  mortgageTerm?: number;
  ownerType?: string;
  contactOwnerMailAddressFull?: string;
}
